import { SmartphotoReport } from './report/smartphoto-report.class';
export class SmartphotoReports {
    grouping;
    editable;
    reports;
    constructor(configuration, mismatchedPartIds = []) {
        const { attributes, reports } = configuration;
        this.grouping = attributes.grouping;
        this.reports = reports.map((report) => new SmartphotoReport(report, mismatchedPartIds));
        this.editable = this.grouping !== 'unique';
        const deletedReport = this.reports.find(({ type }) => type === 'deleted');
        if (!deletedReport) {
            this.reports.push(new SmartphotoReport({
                uuid: crypto.randomUUID(),
                is_main_report: false,
                damages: [],
                report_type: 'deleted'
            }));
        }
        const secondaryReports = this.reports.filter(({ main, type }) => !main && type !== 'deleted');
        if (secondaryReports.length === 0 && this.grouping !== 'unique' && this.grouping !== 'sides') {
            this.reports.push(new SmartphotoReport({
                uuid: crypto.randomUUID(),
                is_main_report: false,
                damages: [],
                report_type: 'user'
            }));
        }
    }
    findReport(uuid) {
        return this.reports.find((report) => report.uuid === uuid);
    }
    findMainReport() {
        const report = this.reports.find(({ main }) => main);
        if (!report) {
            throw new Error('This data is corrupted');
        }
        return report;
    }
    findDeleteReport() {
        const report = this.reports.find(({ type }) => type === 'deleted');
        if (!report) {
            throw new Error('This data is corrupted');
        }
        return report;
    }
    findOtherReport() {
        const secondary = this.reports.filter(({ damages, main, type }) => !main && type !== 'deleted' && damages.length > 0);
        if (secondary.length > 0) {
            return secondary;
        }
        return this.reports.filter(({ main, type }) => !main && type !== 'deleted').slice(0, 1);
    }
    deleteDamage(damage) {
        damage.setDeleted(true);
        this.move(damage, this.findDeleteReport().uuid);
    }
    addReport(main = false, type = 'user') {
        if (!this.editable) {
            throw new Error('Cant add report to user');
        }
        const mainReport = this.findMainReport();
        if (main && mainReport) {
            throw new Error('There cannot be 2 main reports');
        }
        const report = new SmartphotoReport({
            uuid: crypto.randomUUID(),
            is_main_report: main,
            report_type: type,
            damages: []
        });
        this.reports.push(report);
        return report;
    }
    addDamage(damage, reportUuid) {
        // TODO: Un concepto no es un Daño, refactorizar para crear su propio modelo de conceptos. Con eso esta condicion puede ser eliminada
        if (damage.origin === 'additionalCost') {
            throw new Error('additional cost not is a damage');
        }
        const uuid = reportUuid ?? this.findMainReport().uuid;
        this.move(damage, uuid);
    }
    setReportAsMain(uuid) {
        const report = this.findReport(uuid);
        if (!report) {
            return;
        }
        const main = this.findMainReport();
        main.main = false;
        report.main = true;
    }
    move(damage, uuid) {
        // TODO: Un concepto no es un Daño, refactorizar para crear su propio modelo de conceptos. Con eso esta condicion puede ser eliminada
        if (damage.origin === 'additionalCost') {
            return;
        }
        const destinationReport = this.findReport(uuid);
        if (!destinationReport) {
            throw new Error('Cant move a damage to a non-existent report if not editable');
        }
        this.reports.forEach((report) => {
            const index = report.damages.findIndex((original) => original.uuid === damage.uuid);
            if (index < 0) {
                return;
            }
            report.damages.splice(index, 1);
        });
        destinationReport.add(damage);
    }
    restore(damage) {
        damage.setDeleted(false);
        this.move(damage, this.findMainReport().uuid);
    }
    getAll() {
        return [this.findMainReport(), ...this.findOtherReport(), this.findDeleteReport()];
    }
}
